export default __webpack_public_path__ + "static/media/ic_success.d943dff8.svg";